import { render, staticRenderFns } from "./NotiSmsPaymentReceived.vue?vue&type=template&id=849d5d68&scoped=true"
import script from "./NotiSmsPaymentReceived.vue?vue&type=script&lang=js"
export * from "./NotiSmsPaymentReceived.vue?vue&type=script&lang=js"
import style0 from "./NotiSmsPaymentReceived.vue?vue&type=style&index=0&id=849d5d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849d5d68",
  null
  
)

export default component.exports